import { AppConfigModel } from '@/models/app/app-config';


/**
 *
 * This App Config serializer is responsible for converting the Raw format to model.
 *
 */
export class AppConfigSerializer {
  private static INSTANCE = new AppConfigSerializer();

  static get instance() {
    return this.INSTANCE;
  }

  public appConfigModelSerializer(res: any) {
    const result: AppConfigModel = {
      api_endpoint_url: res.api_endpoint_url,
      showcase_endpoint: res.showcase_endpoint,
      SHOWCASE_DEMO_ACCOUNT: res.SHOWCASE_DEMO_ACCOUNT,
      SHOWCASE_LEARNERS_LIST: res.SHOWCASE_LEARNERS_LIST,
      AI_PLAYGROUND_STUDENT: res.AI_PLAYGROUND_STUDENT,
      tenantUrl: res.tenantUrl,
      adminUiAppId: res.adminUiAppId,
      S3_BUCKET_ASSETS_BASE_PATH: res.S3_BUCKET_ASSETS_BASE_PATH,
      STATIC_IMAGE_URL: res.STATIC_IMAGE_URL,
      loginPageInfo: res.loginPageInfo,
    };
    return result;
  }

  public appPermissionSerializer(res: any, permission: any) {
    let isEnableResearchPage: boolean = false;
    const userRole: any = {
      menus: [],
      pages: {},
    };
    if (permission && permission.length && res) {
      permission.map((pageAccess: any) => {
        Object.keys(res).map((menuPages) => {
          if (!userRole.pages.hasOwnProperty(menuPages)) {
            userRole.pages[menuPages] = [];
          }
          Object.keys(res[menuPages]).map((pages) => {
                if (res[menuPages][pages].indexOf(pageAccess) !== -1) {
                  isEnableResearchPage = pages === 'research-view';
                  if (userRole.menus.indexOf(menuPages) === -1
                          && (pages === `${menuPages}-view` || pages === 'all')) {
                    userRole.menus.push(menuPages);
                  }
                  if (userRole.pages[menuPages].indexOf(pages) === -1) {
                     userRole.pages[menuPages].push(pages);
                  }
                }
            });
        });
      });
    }
    userRole.landingPage  = '/projects';
    // userRole.landingPage = isEnableResearchPage
    //   ? 'projects' : (userRole.menus.indexOf('network') !== -1 ? '/network' :  '/' + userRole.menus[0]);
    return userRole;
  }
}

export const appConfigSerializer = AppConfigSerializer.instance;
